/* 🤖 this file was generated by svg-to-ts */
export const IconBigBrandFacebook: {
    name: 'big-brand-facebook';
    data: string;
} = {
    name: 'big-brand-facebook',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 40 40"><path d="M23.333 38V21.124h5.599l.84-6.577h-6.44v-4.2c0-1.904.522-3.201 3.225-3.201H30V1.258C29.406 1.178 27.36 1 24.983 1c-4.966 0-8.367 3.065-8.367 8.693v4.851H11v6.578h5.616v16.876h6.717z"/></svg>`,
};
